import { render, staticRenderFns } from "./page.vue?vue&type=template&id=ce3d96b2&scoped=true"
import script from "./page.vue?vue&type=script&lang=ts"
export * from "./page.vue?vue&type=script&lang=ts"
import style0 from "./page.vue?vue&type=style&index=0&id=ce3d96b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3d96b2",
  null
  
)

export default component.exports